import { css } from '@emotion/react'
import type { Theme } from '@emotion/react'

import { breakpoint, size } from '@twisto/styles'

export const wrapper = (theme: Theme) => css`
  border-width: 1px;
  border-style: dashed;
  padding: ${size[16]} ${size[24]};
  border-radius: ${size[4]};
  margin-bottom: ${size[20]};
  display: flex;
  flex-direction: column;
  gap: ${size[12]};

  ${breakpoint.up('md')} {
    margin-bottom: ${size[24]};
  }

  a {
    color: ${theme.palette.additionalColor.purple[500]};
    text-decoration: none;
    font-weight: 500;
  }
`

export const colors = {
  danger: (theme: Theme) => css`
    border-color: ${theme.palette.error[500]};
    background-color: ${theme.palette.error[100]};
  `,
  warning: (theme: Theme) => css`
    border-color: ${theme.palette.warning[500]};
    background-color: ${theme.palette.warning[100]};
  `,
  primary: (theme: Theme) => css`
    border-color: ${theme.palette.success[500]};
    background-color: ${theme.palette.success[100]};
  `,
  neutral: (theme: Theme) => css`
    border-color: ${theme.palette.neutral[600]};
    background-color: ${theme.palette.neutral[100]};
  `,
}
